
export default {
  tooManyFiles: "Only maximum of 10 files allowed.",
  fileTooBig: "File size cannot exceed 25mb.",
  fileContainsSpecialCharacter:
    "Special characters and/or spaces are not allowed to be used in the file name. Please rename the file using alpha numeric characters only.",
  fileRejections:
    "File is not supported. Please upload supported file types: .pdf .jpeg .jpg .tiff .tif",
};